import React, {useRef} from "react";
import { t } from "../../../../../../../../../components/Translate";
import Input from "../../../../../../../../../components-new/form/Input";
import config from "../../../../../../../../../config";
import AiBlock from "./AiBlock";

const AiDescriptionEditor = ({
                                 aiType,
                                 aiDescription,
                                 handleAiDescriptionChange,
                                 handleSaveAiDescription,
                                 addNotification,
                                 user
                             }) => {

    const lastSavedValue = useRef(aiDescription);

    function handleSave() {
        try {
            if (aiDescription.trim() === lastSavedValue.current.trim()) return;

            handleSaveAiDescription();
            lastSavedValue.current = aiDescription;
            addNotification("successful", config.notificationLevels.success);
        } catch (e) {
            addNotification("somethingWentWrong", config.notificationLevels.error);
        }
    }

    // the guard sits after the hooks on purpose: returning earlier would change the
    // number of hooks between renders, and React fails the whole screen when the
    // company switches its AI type in the selector above
    if (aiType !== config.AITypes.GPT_AI && aiType !== config.AITypes.GEMINI_AI
        && aiType !== config.AITypes.TEAM_AI && aiType !== config.AITypes.TEAM_AI_TEST) return null;

    return (
        <AiBlock titleKey="aiInstructions" hintKey="AIExplanation">
            <Input
                resize={'vertical'}
                isTextarea={true}
                placeholder={t({ text: "aiDescriptionExample", user })}
                value={aiDescription}
                onChange={handleAiDescriptionChange}
                style={{ minHeight: '150px' }}
                onBlur={handleSave}
            />
        </AiBlock>
    );
};

export default AiDescriptionEditor;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiDescriptionEditor.jsx